document.addEventListener("DOMContentLoaded", function () {
  // Initialize Video Modal
  initVideoModal();

  // Check if main-swiper exists
  const swiperElement = document.querySelector(".main-swiper");
  if (!swiperElement) return;

  // Initialize mainSwiper and store globally for color-based image updates
  window.mainSwiper = new Swiper(".main-swiper", {
    spaceBetween: 10,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 500,
    on: {
      slideChangeTransitionEnd: function () {
        this.slides.forEach((slide) => {
          const vid = slide.querySelector("video");
          if (vid) {
            vid.pause();
            vid.currentTime = 0;
          }
        });

        const currentSlide = this.slides[this.activeIndex];
        const video = currentSlide.querySelector("video");
        if (video) {
          video.muted = true;
          video.play();

          const btn = currentSlide.querySelector(".mute-btn");
          if (btn) {
            // btn.style.backgroundImage = `url('${muteIcon}')`;
          }
        }
      },
    },
  });

  const prevArrow = document.getElementById("prevArrow");
  const nextArrow = document.getElementById("nextArrow");
  const prevArrowMobile = document.getElementById("prevArrowMobile");
  const nextArrowMobile = document.getElementById("nextArrowMobile");

  const updateMobileArrows = () => {
    if (prevArrowMobile) {
      prevArrowMobile.classList.toggle("inactive", window.mainSwiper.isBeginning);
    }
    if (nextArrowMobile) {
      nextArrowMobile.classList.toggle("inactive", window.mainSwiper.isEnd);
    }
  };

  if (prevArrowMobile) {
    prevArrowMobile.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!window.mainSwiper.isBeginning) {
        window.mainSwiper.slidePrev();
      }
    });
  }

  if (nextArrowMobile) {
    nextArrowMobile.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!window.mainSwiper.isEnd) {
        window.mainSwiper.slideNext();
      }
    });
  }

  window.mainSwiper.on("slideChange", updateMobileArrows);
  updateMobileArrows();

  if (!prevArrow || !nextArrow) return;

  const updateArrows = () => {
    prevArrow.classList.toggle("inactive", window.mainSwiper.isBeginning);
    nextArrow.classList.toggle("inactive", window.mainSwiper.isEnd);
  };

  // Click actions
  prevArrow.addEventListener("click", () => {
    if (!window.mainSwiper.isBeginning) {
      window.mainSwiper.slidePrev();
    }
  });

  nextArrow.addEventListener("click", () => {
    if (!window.mainSwiper.isEnd) {
      window.mainSwiper.slideNext();
    }
  });

  const updateCustomDots = (swiper) => {
    const dots = document.querySelectorAll("#custom-dots .dot");
    const total = swiper.slides.length;
    const active = swiper.activeIndex;

    let activeDotIndex = 1;
    if (active === 0) activeDotIndex = 0;
    else if (active === total - 1) activeDotIndex = 2;

    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === activeDotIndex);
    });

    updateArrows();
  };

  // Make updateCustomDots globally accessible
  window.updateCustomDots = updateCustomDots;

  window.mainSwiper.on("slideChange", () =>
    updateCustomDots(window.mainSwiper)
  );
  updateCustomDots(window.mainSwiper); // first time

  // Mobile pagination functionality
  const updateMobilePagination = (swiper) => {
    const mobileDots = document.querySelectorAll("._1_pp_pagdot");
    const activeIndex = swiper.activeIndex;

    mobileDots.forEach((dot, index) => {
      dot.classList.toggle("active", index === activeIndex);
    });
  };

  // Make updateMobilePagination globally accessible
  window.updateMobilePagination = updateMobilePagination;

  // Add click functionality to mobile dots
  const mobileDotWrappers = document.querySelectorAll("._1_pp_pagdot_wrp");
  mobileDotWrappers.forEach((wrapper) => {
    wrapper.addEventListener("click", () => {
      const slideIndex = parseInt(wrapper.getAttribute("data-slide-index"));
      if (!isNaN(slideIndex)) {
        window.mainSwiper.slideTo(slideIndex);
      }
    });
  });

  // Update mobile pagination on slide change
  window.mainSwiper.on("slideChange", () =>
    updateMobilePagination(window.mainSwiper)
  );
  updateMobilePagination(window.mainSwiper); // Initialize
});

// ---------------------------------------------
// Video Modal Logic (Reusable)
// ---------------------------------------------
function initVideoModal() {
  const modal = document.getElementById("ab-video-modal");
  if (!modal) return;

  const body = document.body;
  const backdrop = modal.querySelector(".ab-video-modal__backdrop");
  const closeEls = modal.querySelectorAll("[data-video-modal-close]");
  const container = modal.querySelector(".ab-video-modal__body");

  // Open: delegate on document for dynamic elements
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".video-modal-trigger");
    if (!trigger) return;
    e.preventDefault();

    const src = trigger.getAttribute("data-video-src");
    if (!src || !container) return;

    // Remember last trigger for focus
    modal._lastTrigger = trigger;

    // Immediately blur the trigger so no focus outline lingers
    try {
      trigger.blur();
    } catch (_) {}

    // Inject <video>
    container.innerHTML = "";
    const video = document.createElement("video");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.controls = true;
    video.preload = "metadata";
    video.style.width = "100%";
    video.style.height = "auto";

    // HLS support: if .m3u8, use hls.js (or native on Safari)
    const isHls = /\.m3u8(\?|$)/i.test(src);
    try {
      if (isHls) {
        if (window.Hls && window.Hls.isSupported()) {
          const hls = new window.Hls({
            maxBufferLength: 30,
            startPosition: -1,
            lowLatencyMode: true,
          });
          hls.loadSource(src);
          hls.attachMedia(video);
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          // Safari
          video.src = src;
        } else {
          // Fallback: browser cannot play HLS
          console.warn(
            "HLS not supported in this browser and hls.js not available."
          );
          video.src = "";
        }
      } else {
        // MP4 or other progressive formats
        video.src = src;
      }
    } catch (err) {
      console.error("Error initializing video source", err);
      video.src = isHls ? "" : src;
    }

    container.appendChild(video);

    // Show modal (use flex to center contents)
    modal.style.display = "flex";
    modal.setAttribute("aria-hidden", "false");
    body.classList.add("ab-modal-no-scroll");

    // Autoplay (may be blocked if sound on)
    try {
      video.play();
    } catch (_) {}

    // Focus close
    const closeBtn = modal.querySelector(".ab-video-modal__close");
    if (closeBtn)
      setTimeout(() => {
        try {
          closeBtn.focus();
        } catch (_) {}
      }, 0);
  });

  // Close helpers
  function closeModal() {
    if (container) container.innerHTML = "";
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
    body.classList.remove("ab-modal-no-scroll");
    if (modal._lastTrigger && typeof modal._lastTrigger.focus === "function") {
      try {
        modal._lastTrigger.focus();
      } catch (_) {}
    }
  }

  // Backdrop click
  if (backdrop) backdrop.addEventListener("click", closeModal);

  // Close buttons
  closeEls.forEach((el) => {
    el.addEventListener("mousedown", function () {
      try {
        el.blur();
      } catch (_) {}
    });
    el.addEventListener("click", function (e) {
      try {
        el.blur();
      } catch (_) {}
      closeModal(e);
    });
  });

  // ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
      e.preventDefault();
      closeModal();
    }
  });
}
